import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import './UrlDataReportsControls.scss';

const STATUS_TABS = [
  { id: 'queue', label: 'Queue' },
  { id: 'open', label: 'Open' },
  { id: 'requeued', label: 'Requeued' },
  { id: 'resolved', label: 'Resolved' },
  { id: 'dismissed', label: 'Dismissed' },
  { id: 'all', label: 'All' }
];

const UrlDataReportsControls = ({
  status,
  onStatusChange,
  liveOnly,
  onToggleLiveOnly,
  wrongBrandOnly,
  onToggleWrongBrandOnly,
  page,
  pageCount,
  onPageChange
}) => (
  <div className='url-data-reports-controls'>
    <div className='udrc-filters'>
      <label className={cn('udrc-toggle', { on: liveOnly })}>
        <input type='checkbox' checked={liveOnly} onChange={onToggleLiveOnly} />
        Live opportunity
      </label>
      <label className={cn('udrc-toggle', { on: wrongBrandOnly })}>
        <input type='checkbox' checked={wrongBrandOnly} onChange={onToggleWrongBrandOnly} />
        Wrong brand
      </label>
      <div className='udrc-pager'>
        <button type='button' className='udrc-page-btn' disabled={page <= 1} onClick={() => onPageChange(page - 1)}>
          Prev
        </button>
        <span>
          {page} / {pageCount}
        </span>
        <button type='button' className='udrc-page-btn' disabled={page >= pageCount} onClick={() => onPageChange(page + 1)}>
          Next
        </button>
      </div>
    </div>
    <nav className='udrc-tabs' aria-label='Report status'>
      {STATUS_TABS.map(tab => (
        <button
          key={tab.id}
          type='button'
          className={cn('udrc-tab', { active: status === tab.id })}
          onClick={() => onStatusChange(tab.id)}
        >
          {tab.label}
        </button>
      ))}
    </nav>
  </div>
);

UrlDataReportsControls.propTypes = {
  status: PropTypes.string.isRequired,
  onStatusChange: PropTypes.func.isRequired,
  liveOnly: PropTypes.bool.isRequired,
  onToggleLiveOnly: PropTypes.func.isRequired,
  wrongBrandOnly: PropTypes.bool.isRequired,
  onToggleWrongBrandOnly: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  pageCount: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired
};

export default UrlDataReportsControls;
